'use client'

import React from 'react'
import { VStack, Text, Box, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'

import ProductSales from '@images/brands/cheongdam/product-sales.png'
import TriangleCenterLineImage from '@images/brands/cheongdam/triangle-center-line.png'

const ExclusiveOffer = () => {
  return (
    <VStack w={'100%'}>
      <VStack gap={2} data-aos="fade-up">
        <Text textStyle={'exclusiveText'} textTransform={'uppercase'}>
          Full grey hair coverage in
        </Text>
        <Text textStyle={'exclusiveText'} textTransform={'uppercase'}>
          Just 5 shampooing times
        </Text>
      </VStack>

      <VStack
        gap={6}
        my={{
          md: 8,
          base: 4
        }}
      >
        <Text
          data-aos="fade-up"
          textAlign={'center'}
          textStyle={'exclusiveTitle'}
        >
          Exclusive Offer
        </Text>
        <Image
          data-aos="fade-up"
          alt=""
          src={TriangleCenterLineImage}
          sizes="100vw"
          style={{ width: '100%' }}
        />
      </VStack>

      <AspectRatio
        data-aos="fade-up"
        mb={{
          md: 8,
          base: 4
        }}
        ml={{
          base: '-56px',
          sm: '-71px'
        }}
        w={{
          base: '280px',
          sm: '350px'
        }}
        ratio={420 / 446}
      >
        <Image src={ProductSales} fill alt="guardian" className="mt-8" />
      </AspectRatio>
    </VStack>
  )
}

export default ExclusiveOffer
